import {
    FeatureEnum
} from './featureAccess.enum';

export enum StateFacetEnum {
    ACCOUNT = 'account',
    STATUS = 'status',
    DIAGNOSTIC = 'diagnostic',
    PHONE = 'phone',
    SUBSCRIPTION = 'subscription',
    HAS_PAYMENT = 'has_payment',
    EVER_SUBSCRIBED = 'ever_subscribed',
    IS_ACTIVE = 'is_active',
    RECEIVING_TEXTS = 'receiving_texts',
    TRACKING_CONTEXT = 'tracking_context',
    WEEKLY_PLAN_CREATION_CONTEXT = 'weekly_plan_creation_context',
    CURRENT_PLANNING_WEEK = 'current_planning_week',
    UPCOMING_PLANNING_WEEK = 'upcoming_planning_week',
    COMPLETED_FIRST_TIME_PLAN_FLOW = 'completed_first_time_plan_flow',
    PLAN_REQUESTED_ON_DEMAND = 'plan_requested_on_demand',
    PLAN_REQUESTED_IS_PENDING = 'plan_requested_is_pending',
    PLAN_REQUESTED_CHANNELS = 'plan_requested_channels',
    COMPLETED_APP_FIRST_TIME_TUTORIAL = 'updated_app_first_time_tutorial',
    DISMISSED_PROGRESS_SETTING_EDUCATION_CARD = 'dismissed_progress_setting_education_card',
    DISMISSED_COMMUNITY_SETTING_EDUCATION_CARD = 'dismissed_community_setting_education_card',
    HUMAN_COACHING_REQUESTED = 'human_coaching_requested',
    HUMAN_COACHING_REQUESTED_RESPONDED = 'human_coaching_requested_responded',
    DISMISSED_TEXT_SETUP_BANNER = 'dismissed_text_setup_banner',
    DISMISSED_MED_PILL_BANNER = 'dismissed_med_pill_banner',
    MED_REACHED_CHECKOUT = 'med_reached_checkout',
    CONFIRMED_MED_SHIPPING_ADDRESS = 'confirmed_med_shipping_address',
    SCHEDULED_SYNC_VISIT = 'scheduled_sync_visit',
    COMPLETED_SYNC_VISIT = 'completed_sync_visit',
    COMPLETED_MED_FIRST_NUX_ONBOARDING = 'completed_med_first_nux_onboarding',
    DISQUALIFIED_FROM_MED = 'disqualified_from_med',
    SYNC_VISIT_REQUIRED_REASON = 'sync_visit_required_reason'
}

interface User {
    __featureAccess__?: Array<{ feature: string }>;
}

/**
 * Checks if a user has access to a specific feature or any feature from a list based on their feature flags
 * @param user The user object containing feature access information
 * @param feature The feature or array of features to check access for
 * @returns boolean indicating whether the user has access to the feature(s)
 */
export const userHasAccess = (user: User, feature: FeatureEnum | FeatureEnum[]): boolean => {
    const userFeatures = user?.__featureAccess__ || [];
    const featuresToCheck = Array.isArray(feature) ? feature : [feature];
    const hasAccess = userFeatures?.some(f => featuresToCheck.includes(f.feature as FeatureEnum));
    return hasAccess;
};
